import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';
import Colors from '../../layout/theme/utils/colors';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    checkboxHolder: {
      margin: theme.spacing(0, 0, 2.5, 0),
      '& .MuiTypography-root': {
        fontWeight: 'normal',
        fontSize: 14,
        color: Colors.almost_black,
        paddingLeft: theme.spacing(1.125),
        '& .MuiFormControlLabel-label.Mui-disabled': {
          color: Colors.almost_black,
        },
      },
    },
    outerBox: {
      padding: theme.spacing(1.875),
      width: '100%',
    },
    generalInfo: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '21px',
      color: Colors.almost_black,
    },
    releaseDate: {
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '15px',
      color: Colors.almost_black,
    },
    released: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      color: Colors.almost_black,
      marginTop: '10px',
    },
  }),
);
